var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 6.429,
  stroke: "currentColor",
  strokeWidth: 0.8
}), /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  transform: "translate(6.675 3.696)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.83 0a.65.65 0 0 1 .65.67l-.126 4.045a.497.497 0 0 1-.497.481.5.5 0 0 1-.502-.481L.188.669A.643.643 0 0 1 .83 0"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 0.83,
  cy: 6.884,
  r: 1
})))));
export default SvgIcInfo;